import React from 'react';
import { Check, Star } from 'lucide-react';

const Pricing: React.FC = () => {
  const plans = [
    {
      name: "Básico",
      price: "$100.000",
      period: "/mes",
      description: "Perfecto para instituciones pequeñas o proyectos piloto",
      popular: false,
      features: [
        "Hasta 100 usuarios",
        "5 GB de almacenamiento",
        "Dominio personalizado",
        "Certificado SSL",
        "Backups semanales",
        "Soporte por email"
      ],
      buttonText: "Comenzar Ahora",
      buttonClass: "btn-secondary"
    },
    {
      name: "Profesional",
      price: "$250.000",
      period: "/mes",
      description: "La opción más popular para instituciones en crecimiento",
      popular: true,
      features: [
        "Hasta 500 usuarios",
        "25 GB de almacenamiento",
        "Dominio personalizado",
        "Certificado SSL",
        "Backups diarios",
        "Soporte prioritario 24/7",
        "Tema personalizado",
        "Plugins premium incluidos"
      ],
      buttonText: "Más Popular",
      buttonClass: "btn-primary"
    },
    {
      name: "Empresarial",
      price: "$500.000",
      period: "/mes",
      description: "Solución completa para grandes instituciones educativas",
      popular: false,
      features: [
        "Usuarios ilimitados",
        "100 GB de almacenamiento",
        "Múltiples dominios",
        "Certificados SSL",
        "Backups en tiempo real",
        "Soporte dedicado 24/7",
        "Personalización completa",
        "Todos los plugins premium",
        "Integraciones avanzadas",
        "SLA del 99.9%"
      ],
      buttonText: "Contactar Ventas",
      buttonClass: "btn-secondary"
    }
  ];

  const additionalServices = [
    {
      service: "Migración de datos",
      price: "$150.000",
      description: "Una sola vez"
    },
    {
      service: "Capacitación personalizada",
      price: "$80.000",
      description: "Por hora"
    },
    {
      service: "Desarrollo de plugin personalizado",
      price: "$400.000",
      description: "Desde"
    },
    {
      service: "Consultoría estratégica",
      price: "$120.000",
      description: "Por hora"
    }
  ];

  return (
    <section id="precios" className="pricing">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Planes y Precios</h2>
          <p className="section-subtitle">
            Elige el plan que mejor se adapte a las necesidades de tu institución
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && (
                <div className="popular-badge">
                  <Star className="star-icon" />
                  Más Popular
                </div>
              )}
              
              <div className="pricing-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>

              <div className="pricing-features">
                <ul className="features-list">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="feature-item">
                      <Check className="check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pricing-footer">
                <a href="#contacto" className={`btn ${plan.buttonClass} btn-full`}>
                  {plan.buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="additional-services">
          <h3 className="services-title">Servicios Adicionales</h3>
          <div className="services-grid">
            {additionalServices.map((service, index) => (
              <div key={index} className="additional-service">
                <div className="service-info">
                  <h4 className="service-name">{service.service}</h4>
                  <p className="service-desc">{service.description}</p>
                </div>
                <div className="service-price">
                  {service.price}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pricing-notice">
          <p>
            <strong>Nota:</strong> Todos los precios están en Pesos Chilenos (CLP) e incluyen IVA. 
            Los planes incluyen soporte técnico y actualizaciones de seguridad. 
            Contrato mínimo de 12 meses con descuentos por pago anual.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;